import { AUTO_COMPLETE_SUGGESTION_TYPES } from "SrcPath/GlobalSearch/constants";
import { platform } from "GlobalEnum/Platform";

export const processAutoCompleteResponse = response => {
  const data = {
    label: response.displayName,
    suggestiontype: response.suggestionType,
  };
  if (
    response.suggestionType === AUTO_COMPLETE_SUGGESTION_TYPES.newModel &&
    response.payload &&
    response.payload.makeMaskingName &&
    response.payload.maskingName
  ) {
    data.makemaskingname = response.payload.makeMaskingName;
    data.modelmaskingname = response.payload.maskingName;
  }
  return data;
};

export const isValidResponse = state => {
  const { launchedCars, makeList, popularCars, upcomingCars } = state;
  return (
    launchedCars.length > 0 ||
    makeList.length > 0 ||
    popularCars.length > 0 ||
    upcomingCars.length > 0
  );
};

export const getSearchClickTrackObject = (
  cityId,
  cityMaskingName,
  lowerBudgetLimit,
  upperBudgetLimit,
  platForm
) => {
  const isMobile = platForm.id === platform.MOBILE.id;
  const isCityAvailable = cityId > 0;
  const isBudgetAvailable = lowerBudgetLimit > 0 || upperBudgetLimit > 0;
  const lowerBudgetText = lowerBudgetLimit > 0 ? `${lowerBudgetLimit} L` : "";
  const upperBudgetText = upperBudgetLimit > 0 ? `${upperBudgetLimit} L` : "";
  const gaCat = isMobile ? "FirstPanel-Mobile-HP" : "FirstPanel-Desktop-HP";
  let gaActClick = "";
  let gaLblClick = `${cityMaskingName}`;
  if (isMobile) {
    gaActClick = isCityAvailable
      ? `UsedCar-city-set-find-car`
      : `UsedCar-city-not-set-find-car`;
  } else {
    if (isCityAvailable && isBudgetAvailable) {
      gaActClick = `UsedCar-Successful-Budget-City-Find-Car`;
      gaLblClick = `${gaLblClick} ${lowerBudgetText} - ${upperBudgetText}`;
    } else if (isCityAvailable) {
      gaActClick = `UsedCar-Successful-only-City-Find-Car`;
    } else if (isBudgetAvailable) {
      gaActClick = `UsedCar-Successful-only-budget-Find-Car`;
    } else {
      gaActClick = `UsedCar-UnSuccessful-Find-Car`;
    }
  }
  return { gaCat, gaActClick, gaLblClick };
};
